import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GenerateNewAPIKeyRPC } from "./generateNewApiKeyRPC";

export class GenerateNewAPIKeyRPCClientImpl extends GenerateNewAPIKeyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GenerateNewAPIKeyRPC.Request): Promise<LeoRPCResult<GenerateNewAPIKeyRPC.Response, GenerateNewAPIKeyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "external-public-apis/GenerateNewAPIKey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GenerateNewAPIKeyRPC.ResponseDTO,
      GenerateNewAPIKeyRPC.Errors.ErrorsDTO,
      GenerateNewAPIKeyRPC.Response,
      GenerateNewAPIKeyRPC.Errors.Errors
    >(
      response,
      "external-public-apis/GenerateNewAPIKey",
      GenerateNewAPIKeyRPC.Response.fromDTO,
      GenerateNewAPIKeyRPC.Errors.fromDTO
    );
  }
}
